/**
 * 考勤管理 API（管理端）
 * 后端：/api/attendance
 */
import { request, buildUrl } from './request'

/**
 * 获取班级考勤概览
 * GET /api/attendance/classes
 * @param {object} params - { start_date?, end_date?, query_date?, grade_id?, period_config_id?, page?, page_size? }
 */
export function getAttendanceClasses(params = {}) {
  const url = buildUrl('/api/attendance/classes', {
    start_date: params.start_date,
    end_date: params.end_date,
    query_date: params.query_date,
    grade_id: params.grade_id,
    period_config_id: params.period_config_id,
    page: params.page,
    page_size: params.page_size
  })
  return request(url)
}
